
$(document).ready(function(){
	/**/
	$('header .hamburger').on('click', function (e){
		e.preventDefault();
		$("body").toggleClass("menu-open");
	});

	$('.btn-load-more ').on('click', 'a', function ( event){
		event.preventDefault();
		var button = $(this),
			data = {
				'action': 'loadmore',
				'query': fcustom_loadmore_params.posts,
				'page' : fcustom_loadmore_params.current_page
			};

		$.ajax({
			url : fcustom_loadmore_params.ajaxurl,
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.css('opacity', 0);
				button.parent('div').prepend('<span class="loading-more">Loading more...</span>');
			},
			success : function( data ){
				button.parent('div').find('.loading-more').remove();
				button.css('opacity', 1);

				if( data ) {
					button.parent('div').parent('main').find('.post-list').append(data);
					fcustom_loadmore_params.current_page++;
					if ( fcustom_loadmore_params.current_page == fcustom_loadmore_params.max_page )
						button.remove();
				} else {
					button.remove();
				}
				gsap.registerPlugin(ScrollTrigger);
				reveal();
			}
		});
	});

	$('.carousel-imgs').slick({
		infinite: true,
		centerMode: true,
		variableWidth: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		pauseOnFocus: false,
		autoplay: true,
	}).on('beforeChange', function(event, slick, currentSlide, nextSlide){

	});;


	$( ".btn-with-circle" ).each(function( index ) {
		$(this).html( '<span>'+$( this ).text()+'</span>' );
		$(this).append(get_icon_svg_grb());
	});

	$( ".btn-with-circle-oval" ).each(function( index ) {
		$(this).html( $( this ).text() );
		$(this).append(get_icon_svg_grb_oval());
	});




});
function get_icon_svg_grb(){
	return '<svg viewBox="0 0 471 89" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
		'<g style="mix-blend-mode:multiply">\n' +
		'<path d="M211.771 86.2311C247.096 84.5049 282.239 81.7584 316.727 77.5154C347.02 73.8403 376.997 69.5434 406.667 64.8212C417.143 63.0332 428.251 61.4284 438.246 59.3158C437.165 58.0587 434.516 57.2298 432.296 56.4145C505.675 42.3428 460.846 17.823 409.924 8.85813C365.358 1.05005 316.49 -0.459513 268.854 0.507518C204.585 2.1732 140.451 9.70221 82.5311 23.5313C56.0359 30.1508 19.0372 40.054 4.7992 52.7725C-13.6444 71.5239 37.9501 83.6024 70.277 86.0594C116.804 89.9294 164.711 88.5357 211.771 86.2311ZM18.9923 74.3011C-7.66109 60.8937 27.5456 44.5323 51.3258 36.0852C136.373 6.99028 252.84 -3.54126 354.552 3.56831C388.529 6.14826 452.147 13.0811 461.918 30.6797C468.541 46.5803 425.896 54.1821 400.32 58.7727C364.972 64.7303 328.252 68.5976 291.345 71.363C281.042 72.1467 270.699 72.7902 260.342 73.3477C249.654 73.8645 238.937 74.4022 228.207 74.4254C227.678 74.4263 227.845 74.7337 227.934 74.8541C230.483 76.8075 234.701 78.3405 239.069 79.3427C283.188 75.2349 328.174 71.5474 371.901 66.0446C295.748 80.8054 213.034 86.873 131.594 87.0072C97.2983 86.5668 45.0789 85.212 18.9924 74.3021L18.9923 74.3011Z" fill="currentColor"/>\n' +
		'</g>\n' +
		'</svg>';
}
function get_icon_svg_grb_oval(){
	return '<svg width="105" height="50" viewBox="0 0 105 50" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
		'<path d="M47.4895 44.9412C55.136 44.1357 62.7431 42.8539 70.2084 40.8739C76.7656 39.1588 83.2545 37.1536 89.677 34.9499C91.9447 34.1155 94.3491 33.3666 96.5126 32.3807C96.2787 31.7941 95.7052 31.4073 95.2247 31.0268C111.108 24.46 101.405 13.0174 90.3821 8.8338C80.7352 5.19003 70.1572 4.48557 59.8457 4.93685C45.934 5.71417 32.0514 9.2277 19.5139 15.6813C13.7787 18.7704 5.76986 23.3919 2.68787 29.3272C-1.30447 38.0778 9.86378 43.7144 16.8613 44.861C26.9326 46.6671 37.3028 46.0167 47.4895 44.9412ZM5.76013 39.3739C-0.00931235 33.1171 7.6116 25.4818 12.7591 21.5398C31.1687 7.96214 56.3792 3.04742 78.3961 6.36522C85.7508 7.5692 99.5217 10.8045 101.637 19.0172C103.07 26.4375 93.8394 29.985 88.3031 32.1273C80.6515 34.9075 72.7031 36.7122 64.7141 38.0027C62.4839 38.3685 60.2451 38.6688 58.0031 38.9289C55.6897 39.1701 53.3698 39.421 51.0473 39.4319C50.9326 39.4323 50.9689 39.5758 50.9881 39.6319C51.5397 40.5435 52.4528 41.2589 53.3984 41.7266C62.9485 39.8096 72.6863 38.0888 82.1515 35.5208C65.6672 42.4092 47.7627 45.2407 30.134 45.3034C22.7104 45.0978 11.4069 44.4656 5.76016 39.3743L5.76013 39.3739Z" fill="currentColor"/>\n' +
		'</svg>';
}
/*
 * ooptimo Scripts File
 * Author: Eddie Machado
 *
 * This file should contain any js scripts you want to add to the site.
 * Instead of calling it in the header or throwing it inside wp_head()
 * this file will be called automatically in the footer so as not to
 * slow the page load.
 *
 * There are a lot of example functions and tools in here. If you don't
 * need any of it, just remove it. They are meant to be helpers and are
 * not required. It's your world baby, you can do whatever you want.
*/

var c_name = "_ooptimo_utmz";

if(getQueryVariable("utm_source") != ""){
	createCookie("_ooptimo_utmz", getQueryVariable("utm_source") + "|" + getQueryVariable("utm_medium")+ "|" + getQueryVariable("utm_term")+ "|" + getQueryVariable("utm_campaign")+ "|" + getQueryVariable("utm_content"), 60);
	createCookie("_ooptimo_utmurl", window.location.href.split('?')[0], 60);
}

if(document.referrer.indexOf(location.protocol + "//" + location.host) === 0){
	createCookie("_ooptimo_utm_referrer", document.referrer, 60);
}

function getQueryVariable(variable){
	var query = window.location.search.substring(1);
	var vars = query.split("&");

	for(var i = 0; i < vars.length; i++){
		var pair = vars[i].split("=");

		if(pair[0] == variable) return pair[1];
	}

	return false;
}

function createCookie(name,value,days){
	var expires = "";

	if(days){
		var date = new Date();

		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toGMTString();
	}

	document.cookie = name + "=" + value+expires+"; path=/";
}

function readCookie(name){
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');

	for(var i=0; i < ca.length; i++){
		var c = ca[i];

		while(c.charAt(0) == ' ') c = c.substring(1, c.length);
		if(c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}

	return null;
}

function eraseCookie(name) {
	createCookie(name, "", -1);
}

/*
 * Get Viewport Dimensions
 * returns object with viewport dimensions to match css in width and height properties
 * ( source: http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript )
*/
function updateViewportDimensions() {
	var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
	return { width:x,height:y };
}

// setting the viewport width
var viewport = updateViewportDimensions();

/*
 * Throttle Resize-triggered Events
 * Wrap your actions in this function to throttle the frequency of firing them off, for better performance, esp. on mobile.
 * ( source: http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed )
*/
var waitForFinalEvent = (function () {
	var timers = {};

	return function (callback, ms, uniqueId) {
		if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
		if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
		timers[uniqueId] = setTimeout(callback, ms);
	};
})();

// how long to wait before deciding the resize has stopped, in ms. Around 50-100 should work ok.
var timeToWaitForLast = 100;


/***************************************************/

function reveal(){
	gsap.set(".reveal", {y: 50});

	ScrollTrigger.batch('.reveal', {
		interval: 0.1,
		batchMax: 3,
		onEnter: batch => {
			gsap.to(batch, {duration: 1.25, opacity: 1, y: 0, stagger: {each: 0.15, grid: [1, 3]}, ease: "expo",
							overwrite: true,
							onComplete: function(){ batch.forEach(item => item.classList.remove('reveal')); }});
		},
	});

	ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".reveal", {y: 0}));

	gsap.set(".reveal_fadeins", {opacity: 0.4});

	ScrollTrigger.batch('.reveal_fadeins', {
		interval: 0.1,
		batchMax: 3,
		onEnter: batch => {
			gsap.to(batch, {duration: 1, opacity: 1,  stagger: {each: 0.15, grid: [1, 3]}, ease: "in",
				overwrite: true,
				onComplete: function(){ batch.forEach(item => item.classList.remove('reveal_fadein')); }});
		},
	});

	//ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".reveal_fadein", {opacity: 1}));

}

document.addEventListener("DOMContentLoaded", function(){
	gsap.registerPlugin(ScrollTrigger);
	reveal();
});

/****
 * effect
 */
// Scroll horizontal amb drag

const hd = document.querySelector('.horizontal-drag');

if(hd){
	let isDown = false;
	let startX;
	let scrollLeft;

	hd.addEventListener('mousedown', (e) => {
		isDown = true;
		hd.classList.add('active');
		startX = e.pageX - hd.offsetLeft;
		scrollLeft = hd.scrollLeft;
		console.log( startX, scrollLeft);
	});

	hd.addEventListener('mouseleave', () => {
		isDown = false;
		hd.classList.remove('active');
	});

	hd.addEventListener('mouseup', () => {
		isDown = false;
		hd.classList.remove('active');
	});

	hd.addEventListener('mousemove', (e) => {
		if(!isDown) return;
		console.log('m');

		e.preventDefault();

		const x = e.pageX - hd.offsetLeft;
		const walk = (x - startX); //scroll-fast

		hd.scrollLeft = scrollLeft - walk;
	});
}